export default {
	UserDetail: {
		PhoneNumberOrEmail: 'Số điện thoại/Email',
		Email: 'Email',
		PhoneNumber: 'Số điện thoại',
		LastName: 'Họ và đệm',
		FirstName: 'Tên',
		Role: 'Vai trò',
		Admin: 'Quản lý',
		User: 'Nhân viên',
		Position: 'Chức danh',
		Cancel: 'Hủy bỏ',
		Save: 'Lưu',
		AddUser: 'Thêm người dùng',
		EditUser: 'Sửa người dùng',
		BatchAssignPermission: 'Phân quyền người dùng',
		ViewUserList: 'Xem danh sách',
		UsersSelected: count => `${count} người dùng đã được chọn.`,
		titleConfirmMisaID: ' đã được sử dụng bởi người dùng dưới đây. Đây có phải người dùng bạn muốn thêm?',
		Accept: 'Thêm',
		Ignore: 'Bỏ qua',
		EditRole: 'Phân quyền người dùng',
		OrganizationUnit: 'Đơn vị',
		Edit: 'Sửa',
		MessageForAdmin: '<b>Quản lý</b> Được phép truy cập tất cả công ty và người dùng',
		MessageForUser: '<b>Nhân viên</b> chỉ được phép truy cập đơn vị được cấp quyền',
		CanWorkingWith: 'Có quyền làm việc với',
		ErrorMiniumOrganization: 'Vui lòng chọn ít nhất 1 đơn vị làm việc.',

		//Bổ sung
		RolePermission: 'Vai trò quyền hạn',
		DivideRoleByUnit: 'Phân quyền theo đơn vị',
		AllUnit: 'Tất cả đơn vị',
		UnitName: 'Tên đơn vị',
		EmaiTakeInvoice: 'Email nhận hóa đơn',
		NoDataSearchUnit:
			'Không tìm thấy thông tin đơn vị theo điều kiện tìm kiếm, vui lòng thử lại',
		DidNotSettingWorkingUnit: 'Bạn chưa thiết lập đơn vị làm việc.',
		ExistEmailOrPhoneByOther:
			'Email hoặc Số điện thoại đã được sử dụng bởi người dùng khác. Vui lòng kiểm tra lại.',
		FullName: 'Họ tên',
		PleaseSelectRole: 'Vui lòng chọn vai trò',
		RequireAtLeastOneUser: 'Vui lòng chọn ít nhất 1 người dùng trước khi tiến hành phân quyền.',
		BackToUserList: 'Quay lại danh sách',
		BatchAssignSuccess: count => `Đã phân quyền thành công cho ${count} người dùng.`,
		BatchAssignPartialSuccess: (success, failed) => `Phân quyền thành công cho ${success} người dùng, thất bại ${failed} người dùng.`,
		BatchAssignFailed: 'Phân quyền thất bại. Vui lòng thử lại.',
		BatchAssignError: 'Có lỗi xảy ra khi cập nhật hàng loạt. Vui lòng thử lại.',
		TextLogWorkingDividePermission: {
			FirstText: 'Phân quyền cho user',
			SecondText: 'làm việc với',
			ThirdText: 'Mã số thuế',
			EndText: 'Email nhận hóa đơn'
		},
		TextLogDestroyPermission: {
			FirstText: 'Hủy quyền làm việc của user',
			SecondText: 'làm việc với',
			ThirdText: 'Mã số thuế',
			EndText: 'Email nhận hóa đơn'
		}
	},
	UserList: {
		UserManager: 'Quản lý người dùng',
		ListUserLogin: 'Danh sách người dùng đăng nhập MISA mTax',
		AddUser: 'Thêm người dùng',
		ConfirmWhenDelete: value =>
			`Người dùng này sẽ không được tiếp tục làm việc với MST ${value} nữa. Bạn có chắc chắn muốn xóa?`,
		ConfirmWhenActive: value => `Người dùng được kích hoạt sẽ được phép làm việc với MST ${value}`,
		ConfirmWhenInActive: value =>
			`Người dùng bị ngừng kích hoạt sẽ không được phép làm việc với MST ${value} cho đến khi được kích hoạt trở lại`,
		Active: 'Kích hoạt',
		Deactivate: 'Ngừng kích hoạt',
		Decentralization: 'Phân quyền',
		DecentralizedUse: 'Phân quyền sử dụng',
		SearchPlaceHolder: 'Nhập Họ tên, Email, Số điện thoại để tìm kiếm',

		//Bổ sung
		AlertUserWillDelete: 'Người dùng sẽ được xóa trên hệ thống và không thể truy cập MISA meInvoice.',
		DeleteUser: 'Xóa người dùng',
		DeleteUserV2: 'Bạn muốn xóa người dùng',
		AlertNeedOneAdminition: 'Phải có ít nhất 1 tài khoản Quản trị',

		// Bulk action
		UserSelected: count => `${count} người dùng`,
		UserListSelected: 'Danh sách người dùng đã chọn',
		TotalUser: 'Tổng số người dùng',
		AssignPermission: 'Phân quyền',
		WarningReplacePermission: 'Danh sách được chọn có người dùng đã được phân quyền, lựa chọn này sẽ thay thế quyền hạn cũ. Bạn có muốn tiếp tục không?',
		AssignPermissionComingSoon: 'Chức năng phân quyền hàng loạt đang được phát triển.',
		CannotAssignPermissionToYourself: 'Bạn không thể phân quyền cho chính mình. Vui lòng chọn người dùng khác.',
		NoDataSearch: 'Không tìm thấy thông tin người dùng theo điều kiện tìm kiếm, vui lòng thử lại'
	},
	DeleteUser: {
		Agree: 'Đồng ý',
		Cancel: 'Hủy bỏ',
		ContentWarringDelete: value =>
			`Người dùng này sẽ không được tiếp tục làm việc với MST <strong> ${value}. </strong> Bạn có chắc chắn muốn xóa?`,
		Success: 'Đã xóa người dùng thành công'
	},

	//Bổ sung
	AddPermission: 'Thêm mới chức danh',
	Description: 'Mô tả',
	DescriptionPlaceholder: 'Nhập mô tả chức danh tại đây',
	AddAccess: 'Thêm thành công',
	ExistPermission: 'Đã tồn tại tên chức danh này',

	//Bổ sung 2/12
	StopUse: 'Ngừng sử dụng',

	//Bổ sung 6/12
	EditSuccess: 'Sửa thành công',

	AddPermission: 'Thêm mới chức danh'
};
